// extracted by mini-css-extract-plugin
module.exports = {"steps_title":"Steps_steps_title__9u2sK","steps_section":"Steps_steps_section__oNn8h"};